export enum ServerName {
  ContractorGraphQL = 'ContractorGraphQL',
  RBSGraphQL = 'RBSGraphQL',
}
